
import { baseUrl } from "../../constants/Constant";
import { fetchAllRack } from "../../resources/RackResource";
import { fetchAllWarehouse } from "../../resources/WarehouseResource";
import FabricCanvasVisualization from "../../utils/FabricCanvasVisualization";
import React, { useEffect, useState } from "react";
import ErrorNotFound from "../errors/Error";
import { getLocalAuth } from "../../utils/AuthUtils";

function Visualization() {
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter(data => {
    return data.code === "Warehouse Visualization"
  });

  let dataRead = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Read"
  });

  const [dataRack, setDataRack] = useState([]);
  const [dataWarehouse, setDataWarehouse] = useState([]);
  const [warehouseIdFilter, setWarehouseIdFilter] = useState("default");

  const fetchRack = () => {
    fetchAllRack()
      .then((res) => {
        setDataRack(res.data);
      })
      .catch((err) => {
        setDataRack([]);
      });
  };

  const fetchWarehouse = () => {
    fetchAllWarehouse()
      .then((res) => {
        setWarehouseIdFilter(res.data[0].id)
        setDataWarehouse(res.data);
      })
      .catch((err) => {
        setDataWarehouse([]);
      });
  };

  let filteredItems = dataRack.filter(item => {
    // eslint-disable-next-line
    return item.warehouse_id == warehouseIdFilter;
  });

  let filteredItemsWarehouse = dataWarehouse.filter(item => {
    // eslint-disable-next-line
    return item.id == warehouseIdFilter;
  });

  useEffect(() => {
    fetchRack();
    fetchWarehouse();
  }, []);

  const onChangeHandlerWarehouseFilter = (e) => {
    const selectedValue = e.target.value;
    setWarehouseIdFilter(selectedValue);
  };

  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row gy-3">
                    <div className="col-md">
                      <h4 className="mb-0">Warehouse Visualization</h4>
                    </div>
                    <div className="col-md-auto">
                      <span className="badge bg-info" style={{ marginRight: '8px' }}>Filled</span>
                      <span className="badge bg-danger" style={{ marginRight: '8px' }}>Full</span>
                      <span className="badge bg-secondary">Empty</span>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-3">
                    <select className="form-select mb-3" aria-label="Default select example"
                      value={warehouseIdFilter}
                      onChange={(e) => onChangeHandlerWarehouseFilter(e)}>
                      <option value="default" disabled>Select Warehouse</option>
                      {
                        dataWarehouse.map((data) => {
                          return (<option id={data.id}
                            key={data.id}
                            value={data.id}>{data.name}</option>);
                        })
                      }
                    </select>
                  </div>
                </div>
                <div className="table-responsive">
                  <div style={{
                    width: '100%',
                    height: '650px',
                    backgroundImage: `url('${baseUrl}/${filteredItemsWarehouse.length === 0 ? '' : filteredItemsWarehouse[0].image}')`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                  }}>
                    <FabricCanvasVisualization initialBoxData={filteredItems} warehouseId={warehouseIdFilter} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Visualization;
